import { takeLatest, put, call } from "redux-saga/effects";
import {
    GET_CONTACT_SUPPORT_LIST_ACTION,
    GET_CONTACT_SUPPORT_LIST_LOADING,
    GET_CONTACT_SUPPORT_LIST_SUCCESS,
    GET_CONTACT_SUPPORT_LIST_ERROR,
    CREATE_CONTACT_SUPPORT_REQUEST_ACTION,
    CREATE_CONTACT_SUPPORT_REQUEST_LOADING,
    CREATE_CONTACT_SUPPORT_REQUEST_ERROR,
    CREATE_CONTACT_SUPPORT_REQUEST_SUCCESS,
    ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ACTION,
    ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ERROR,
    ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_LOADING,
    ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_SUCCESS
} from "./types";

import Api from './api'

function* getContactSupportListSaga(data) {
    yield put({ type: GET_CONTACT_SUPPORT_LIST_LOADING });
    try {
        let res = yield call(Api.getContactSupportRequest, data.payload);
        if (res.message) {
            yield put({ type: GET_CONTACT_SUPPORT_LIST_ERROR, payload: res.message });
        } else yield put({ type: GET_CONTACT_SUPPORT_LIST_SUCCESS, payload: res });
    } catch (error) {
        yield put({ type: GET_CONTACT_SUPPORT_LIST_ERROR, payload: error.message });
    }
}

function* createContactSupporRequestSaga(data) {
    yield ({ type: CREATE_CONTACT_SUPPORT_REQUEST_LOADING })
    try {
        let res = yield call(Api.createContactSupportRequest, data.payload);
        if (res.message) {
            yield put({ type: CREATE_CONTACT_SUPPORT_REQUEST_ERROR, payload: res.message });
        } else yield put({ type: CREATE_CONTACT_SUPPORT_REQUEST_SUCCESS, payload: res });
    } catch (error) {
        yield put({ type: CREATE_CONTACT_SUPPORT_REQUEST_ERROR, payload: error.message });
    }
}

function* addContactSupportRequestResponseSaga(data) {
    yield ({ type: ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_LOADING })
    try {
        let res = yield call(Api.addContactSupportResponse, data.contact_id, data.payload);
        if (res.message) {
            yield put({ type: ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ERROR, payload: res.message });
        } else yield put({ type: ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_SUCCESS, payload: res });
    } catch (error) {
        yield put({ type: ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_SUCCESS, payload: error.message });
    }
}



export default function* watchContactSupportAsync() {
    yield takeLatest(GET_CONTACT_SUPPORT_LIST_ACTION, getContactSupportListSaga)
    yield takeLatest(CREATE_CONTACT_SUPPORT_REQUEST_ACTION, createContactSupporRequestSaga)
    yield takeLatest(ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ACTION, addContactSupportRequestResponseSaga)
}